import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { Box, Button, DialogContent, Typography } from '@mui/material'
import { PaymentElement, useElements, useStripe } from '@stripe/react-stripe-js'
import PropTypes from 'prop-types'

export default function StripeCheckoutForm({
  handleNext,
  setDialogOpen,
  setPayIntentOpen,
  handleBack,
  variant
}) {
  const stripe = useStripe()
  const elements = useElements()
  const navigate = useNavigate()
  const shopUrl = `${window.location.origin}/payment-success`
  const onboardUrl = `${window.location.origin}/order-success`
  const returnUrl = variant === 'onboarding' ? onboardUrl : shopUrl

  const [errorMessage, setErrorMessage] = useState(null)

  const handleSubmit = async (event) => {
    // We don't want to let default form submission happen here,
    // which would refresh the page.
    event.preventDefault()

    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return
    }

    const { error: stripeError } = await stripe.confirmPayment({
      // `Elements` instance that was used to create the Payment Element
      elements,
      redirect: 'if_required',
      confirmParams: {
        return_url: returnUrl
      }
    })

    if (stripeError) {
      // This point will only be reached if there is an immediate error when
      // confirming the payment. Show error to your customer (for example, payment
      // details incomplete)
      setErrorMessage(stripeError.message)
    } else {
      // Your customer will be redirected to your `return_url`. For some payment
      // methods like iDEAL, your customer will be redirected to an intermediate
      // site first to authorize the payment, then redirected to the `return_url`.
      try {
        toast.success('Payment completed.')
        setDialogOpen(false)
        setPayIntentOpen(false)
        if (variant === 'onboarding') {
          navigate('/order-success')
        } else {
          handleNext()
        }
      } catch (error) {
        toast.error('Error updating order. Please try again later!')
      }
    }
  }

  return (
    <>
      <DialogContent
        sx={{
          display: 'flex',
          justifyContent: 'center',
          padding: '24px 38px'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%'
          }}
        >
          <form onSubmit={handleSubmit}>
            <PaymentElement />
            <Box sx={{ display: 'flex', flexDirection: 'row-reverse' }}>
              <Button
                type='submit'
                sx={{ marginTop: '10px' }}
                disabled={!stripe}
                variant='contained'
              >
                Submit
              </Button>
              <Button
                sx={{ marginTop: '10px', marginRight: '10px' }}
                onClick={handleBack}
              >
                Back
              </Button>
            </Box>
            {/* Show error message to your customers */}
            {errorMessage && <Typography>{errorMessage}</Typography>}
          </form>
        </Box>
      </DialogContent>
    </>
  )
}

StripeCheckoutForm.propTypes = {
  handleNext: PropTypes.func.isRequired,
  setDialogOpen: PropTypes.func.isRequired,
  setPayIntentOpen: PropTypes.func.isRequired,
  handleBack: PropTypes.func,
  metaInfo: PropTypes.object,
  variant: PropTypes.string
}
